import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const initialValuesForm1 = {
  title: '',
  branch: '',
  client_id: 0,
  description: '',
};

export const validationSchemaForm1 = Yup.object({
  title: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  assign: Yup.string().optional(),
  description: Yup.string().optional(),
});

export const validationSchemaTickets = Yup.object({
  title: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  assign: Yup.string().optional(),
  description: Yup.string().optional(),
  state: Yup.string().optional(),
});


export type Form1Values = typeof initialValuesForm1;



export const initialValuesForm2 = {
  name_task: '',
  date_task: '',
  support: 0,
  labels_id: [],
  client_id: 0,
};

export const validationSchemaForm2 = Yup.object({
  name_task: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  date_task: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  support: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  labels_id: Yup.array().min(1, 'At least one tag is required'),
});

export type Form2Values = typeof initialValuesForm2;



export const initialValuesNotes = {
  title: '',
  description: '',
};

export const validationNotesSchema = Yup.object({
  title: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  description: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});


export type NotesValues = typeof initialValuesNotes;
